<script setup>
import { provide } from 'vue';
import { LANDING_KEY } from './composables/useLanding';
import { useLandingTracker } from './composables/useLandingTracker';
import { useMetaPixel } from './composables/useMetaPixel';
import { useOpenaiPixel } from './composables/useOpenaiPixel';
import { TEMPLATES } from './templates';

const props = defineProps({
  landing: { type: Object, required: true },
});

provide(LANDING_KEY, props.landing);
useLandingTracker(props.landing);
useMetaPixel(props.landing);
useOpenaiPixel(props.landing);

const template = TEMPLATES[props.landing.page];
</script>

<template>
  <component :is="template" />
</template>
